import { ReactTyped } from 'react-typed';
import { ToastContainer } from "react-toastify";
import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";


import './login.css';
import img1 from "./img1.png"
import img2 from "./img2.png"
import img3 from "./img3.png"
import logo from './MarcaTexto.svg';
import logoPequena from './LogoPequena.png';
import SimpleAnime from '../../Libs/SimpleAnime.js';
import { useAuth } from '../../context/AuthContext';
import { postLogin } from "../../services/apiAutenticacao";
import InputGenerico from '../../components/inputGenerico/inputGenerico';
import { erroToastify, erroToastifyTimer, sucessoToastify } from "../../shared/validacaoToastify";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const emailRef = useRef<HTMLInputElement>(null);
  const senhaRef = useRef<HTMLInputElement>(null);
  const [lembrarMe, setLembrarMe] = useState(false);
  const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
  const [formValues, setFormValues] = useState({ email: "", senha: "" });
  // Função para salvar as credenciais no localStorage
  const salvarCredenciais = () => {
    if (lembrarMe) {
      localStorage.setItem('email', formValues.email);
      localStorage.setItem('senha', formValues.senha);
    } else {
      localStorage.removeItem('email');
      localStorage.removeItem('senha');
    }
  };

  // Carregar as credenciais do localStorage quando o componente for montado
  useEffect(() => {
    const savedEmail = localStorage.getItem('email');
    const savedSenha = localStorage.getItem('senha');
    if (savedEmail && savedSenha) {
      setFormValues({ email: savedEmail, senha: savedSenha });
      setLembrarMe(true);
    }
  }, []);

  const handleFieldChange = (name: string, value: string) => {
    setFormValues({ ...formValues, [name]: value });
    setValidacaoAtiva(false);
  };

  //Animação

  useEffect(() => {
    const simpleAnime = new SimpleAnime();
    return () => { };
  }, []);

  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const envioDeDados = {
      NmEmail: formValues.email,
      DsSenha: formValues.senha,
    };
    try {
      const response = await postLogin({ ...envioDeDados });
      const userData = {
        cdUsuario: response.data.cdUsuario,
        nmUsuario: response.data.nmUsuario,
        dsLogin: response.data.dsLogin,
        cdPerfil: response.data.cdPerfil,
        dmBloqueado: response.data.dmBloqueado,
        dmSituacao: response.data.dmSituacao,
        tokenString: response.data.tokenString
      };
      if (userData.dmBloqueado) {
        erroToastifyTimer('Usuário bloqueado. Contacte o administrador do sistema.', { autoClose: 5000 });
        setTimeout(() => {
          navigate("/milshop");
        }, 5000);
        return;
      }
      login(userData);
      salvarCredenciais();
      const successMessage = response.data.message;
      navigate(`/milshop?successMessage=${encodeURIComponent(successMessage)}`);
      window.location.reload();
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Erro desconhecido. Tente novamente mais tarde.';
      erroToastify(errorMessage, { position: 'top-right' });
      setValidacaoAtiva(true);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const successMessage = searchParams.get("successMessage");
    if (successMessage) {
      sucessoToastify(successMessage);
      navigate("/milshop/login");
    }
  }, [location.search, navigate]);
  useEffect(() => {
    if (validacaoAtiva) {
      if (!formValues.email && emailRef.current) {
        emailRef.current.focus();
      } else if (!formValues.senha && senhaRef.current) {
        senhaRef.current.focus();
      }
    }
  }, [validacaoAtiva, formValues.email, formValues.senha]);

  return (
    <>
      <div className="containerLogin">
        <div className={`bkApresentacaoLogin fadeInLeft`} data-anime='200'>
          <h1>
            <ReactTyped
              strings={['Bem-vindo ao MilShop!']}
              typeSpeed={60}
              backSpeed={50}
              loop={false}
              showCursor={true}
              startDelay={600}
              className="bemVindoMilShop"
            />
          </h1>
          <img className="imgBk responsive-none" src={img1} alt="" />
          <img className="imgBk2 responsive-none" src={img2} alt="" />
          <img className="imgBk3 responsive-none" src={img3} alt="" />
          <img className="imgBk4 responsive-none" src={img1} alt="" />
        </div>
        <form className="formularioLogin fadeInRight" onSubmit={handleConfirmar} data-anime='400'>
          <img className="logoLogin responsive-none" src={logo} alt="Logo MilShop" />
          <img className="logoLogin responsive-block" src={logoPequena} alt="Logo MilShop" />
          <h1 className="bemVindoMobile responsive-block">
            <ReactTyped
              strings={['Bem-vindo ao MilShop!']}
              typeSpeed={60}
              backSpeed={50}
              loop={false}
              showCursor={true}
              startDelay={200}
              className="bemVindoMilShop responsive-block"
            />
          </h1>
          <h2 className="subtituloLogin">Faça o login ou <Link className="cadastrase" to="/milshop/usuario/incluir">cadastre-se</Link> e comece a anunciar agora mesmo!</h2>
          <div className="containerFormularioLogin">
            <div className="containerFormulario">
              <div className={`input-wrapper ${formValues.email.length > 0 || (formValues.email.length > 0 && formValues.senha.length > 0) && (emailRef.current && emailRef.current === document.activeElement) ? 'input-focused' : ''}`}>
                <InputGenerico
                  ref={emailRef}
                  name="email"
                  value={formValues.email}
                  onChange={(event) =>
                    handleFieldChange(event.target.name, event.target.value)
                  }
                  className={`${!(formValues.email.length > 2) && validacaoAtiva ? "input-invalid" : ""} focusLogin`}
                  type="text"
                  temLabel={false}
                />
              </div>
              <label htmlFor="email">E-mail</label>
            </div>
            <div className="containerFormulario">
              <div className={`input-wrapper ${formValues.senha.length > 0 || (formValues.senha.length > 0 && formValues.email.length > 0) && (senhaRef.current && senhaRef.current === document.activeElement) ? 'input-focused' : ''}`}>
                <InputGenerico
                  ref={senhaRef}
                  name="senha"
                  value={formValues.senha}
                  onChange={(event) =>
                    handleFieldChange(event.target.name, event.target.value)
                  }
                  className={`form-control ${!formValues.senha && validacaoAtiva ? "input-invalid" : ""} focusLogin`}
                  type="password"
                  temLabel={false}
                />
              </div>
              <label htmlFor="senha">Senha</label>
            </div>
            <div className="esqueceuSenhaELembreDeMim">
              <Link to="/milshop/esqueci-senha" className="esqueciSenha">Esqueci minha senha</Link>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label className="lembrese" htmlFor="lembrarSenha">Lembre-me</label>
                <input
                  id="lembrarSenha"
                  type="checkbox"
                  className="form-check-input"
                  checked={lembrarMe}
                  onChange={(e) => setLembrarMe(e.target.checked)}
                />
              </div>
            </div>
            <div className='mt-4'>
              <Link className='esqueciSenha' to={'/milshop/usuario/incluir'}>Cadastre-se!</Link>
            </div>
          </div>
          <div className="containerBotoes">
            <button disabled={formValues.email.length > 0 && formValues.senha.length > 0 ? false : true} className="botaoLogin btn btn-outline-primary btn-sm" type="submit">LOGIN</button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </>
  );
}
